import React, { lazy, useEffect } from 'react';
import { Route, Routes, useNavigate } from 'react-router-dom';
import { AppRoutes } from './routes';
import OnBoard from './admin/onBoard';
import ResetInitializer from './reset';
import AuthLayout from '../container/profile/authentication/Index';

const Login = lazy(() => import('../container/profile/authentication/overview/SignIn'));
const ForgotPass = lazy(() => import('../container/profile/authentication/overview/ForgotPassword'));
const ResetPass = lazy(() => import('../container/profile/authentication/overview/ResetPassword'));

const AuthRoot = () => {
  const navigate = useNavigate();

  useEffect(() => navigate('/'));
};

const FrontendRoutes = React.memo(() => {
  return (
    <Routes>
      <Route index element={<Login />} />
      <Route path={AppRoutes.resetpassword} element={<ResetPass />} />
      <Route path={AppRoutes.onboard} element={<OnBoard />} />
      <Route path={AppRoutes.forgotPassword} element={<ForgotPass />} />
      <Route path="/reset" element={<ResetInitializer />} />
      <Route path="*" element={<AuthRoot />} />
    </Routes>
  );
});

export default AuthLayout(FrontendRoutes);
